import { useMutation, useQueryClient } from '@tanstack/react-query';
import { AccountPaymentsQueryKeys } from '@enums/react-query-keys';
import { SavedPaymentCard } from '@interfaces/models/paymentMethod';
import PaymentCardService from '@services/payment-card-service';

const useDeletePaymentCard = (userId: string | undefined) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (id: SavedPaymentCard['id']) => PaymentCardService.deletePaymentCard(id),
    onSuccess: () => queryClient.invalidateQueries({ queryKey: [AccountPaymentsQueryKeys.PAYMENT_CARDS, userId] }),
  });
};

export default useDeletePaymentCard;
